import { Industry } from 'src/types';
import { ReactComponent as FinanceIcon } from 'src/assets/images/icons/finance/finance-icon.svg';
import { ReactComponent as InsuranceIcon } from 'src/assets/images/icons/insurance/insurance-icon.svg';
import { ReactComponent as MobileIcon } from 'src/assets/images/icons/mobile/mobile-icon.svg';
import { ReactComponent as GamblingIcon } from 'src/assets/images/icons/gambling/gambling-icon.svg';
import { ReactComponent as RetailIcon } from 'src/assets/images/icons/retail/retail-icon.svg';

export const DEFAULT_INDUSTRY: Industry = 'Finance';

export const INDUSTRY_CARDS = [
  { icon: <FinanceIcon />, name: 'Finance' },
  { icon: <InsuranceIcon />, name: 'Insurance' },
  { icon: <MobileIcon />, name: 'Mobile' },
  { icon: <GamblingIcon />, name: 'Gambling' },
  { icon: <RetailIcon />, name: 'Retail' },
];
